import { render, staticRenderFns } from "./MeineStrecken.vue?vue&type=template&id=0c135c20&scoped=true&"
import script from "./MeineStrecken.vue?vue&type=script&lang=js&"
export * from "./MeineStrecken.vue?vue&type=script&lang=js&"
import style0 from "./MeineStrecken.vue?vue&type=style&index=0&id=0c135c20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c135c20",
  null
  
)

export default component.exports